<template>
  <div id="app">
    <cabecera></cabecera>
    <formulario></formulario>
    <!-- <pie></pie> -->
  </div>
</template>

<script>
import Cabecera from "./components/Cabecera.vue";
import Formulario from "./components/Formulario.vue";
// import Pie from "./components/Pie.vue";

export default {
  name: "app",
  components: {
    Formulario,
    Cabecera
    // Pie
  },
  data() {
    return {
      Version: "0.1"
    };
  }
};
</script>